import type { App } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

export default {
  install: (Vue: App) => {
    const pinia = createPinia()
    pinia.use(piniaPluginPersistedstate)
    Vue.use(pinia)
  }
}
